
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1000 1000","version":"1.1"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',{attrs:{"id":"defs4"}}),_c('path',{attrs:{"d":"M20 140v120h151.61V140H20zm202.457 0v120h144.068V140H222.457zm194.916 0v120h432.203V140H417.373zm483.05 0v120h80.153V140h-80.152z","id":"rect821","fill":"#000","stroke-width":"5.918","stroke-miterlimit":"4","stroke-dasharray":"none"}}),_c('path',{attrs:{"d":"M20 330v120h374.068V330H20zm424.916 0v120h535.66V330h-535.66z","id":"rect821-5","fill":"#000","stroke-width":"5.918","stroke-miterlimit":"4","stroke-dasharray":"none"}}),_c('path',{attrs:{"d":"M20 537.457v120h166.441v-120H20zm217.29 0v120h567.794v-120H237.289zm618.642 0v120h124.644v-120H855.932z","id":"rect821-3","fill":"#000","stroke-width":"5.918","stroke-miterlimit":"4","stroke-dasharray":"none"}}),_c('path',{attrs:{"d":"M20 764.152v120h181.271v-120H20zm232.12 0v120h402.54v-120H252.12zm453.388 0v120h88.984v-120h-88.984zm139.832 0v120h135.236v-120H845.34z","id":"rect821-56","fill":"#000","stroke-width":"5.918","stroke-miterlimit":"4","stroke-dasharray":"none"}})])
          )
        }
      }
    